import { generateId } from '@freelancer/datastore/testing/helpers';
import type { UserConnectionTypeApi } from 'api-typings/users/users';
import {
  UserConnectionContextTypeApi,
  UserConnectionStatusApi,
} from 'api-typings/users/users';
import type { UserConnectionSearch } from './user-connections-search.model';

export interface GenerateUserConnectionsSearchOptions {
  readonly userId: number;
  readonly connectedUserId: number;
  readonly connectionType: UserConnectionTypeApi;
  readonly status?: UserConnectionStatusApi;
  readonly contextType?: UserConnectionContextTypeApi;
  readonly contextReference?: string;
  readonly score?: number;
  readonly timeCreated?: number;
  readonly timeUpdated?: number;
}

export function generateUserConnectionsSearchObject({
  userId,
  connectedUserId,
  connectionType,
  status = UserConnectionStatusApi.ACTIVE,
  contextType = UserConnectionContextTypeApi.PROJECT,
  contextReference = `${generateId()}`,
  score = 1,
  timeCreated,
  timeUpdated,
}: GenerateUserConnectionsSearchOptions): UserConnectionSearch {
  return {
    id: generateId(),
    userId,
    connectedUserId,
    connectionType,
    status,
    contextType,
    contextReference,
    score,
    timeCreated,
    timeUpdated,
  };
}
